
export default function PartnershipProcess() {
  const steps = [
    {
      step: '01',
      title: 'Initial Application',
      description: 'Submit your partnership application with investment capacity and goals',
      duration: '1-2 days'
    },
    {
      step: '02',
      title: 'Qualification Review',
      description: 'Our team reviews your application and conducts initial qualification assessment',
      duration: '3-5 days'
    },
    {
      step: '03',
      title: 'Due Diligence',
      description: 'Comprehensive financial review, background check, and partnership compatibility assessment',
      duration: '1-2 weeks'
    },
    {
      step: '04',
      title: 'Partnership Presentation',
      description: 'Detailed presentation of investment opportunities, financial projections, and partnership terms',
      duration: '1 day'
    },
    {
      step: '05',
      title: 'Legal Documentation',
      description: 'Partnership agreement preparation, legal review, and contract finalization',
      duration: '2-3 weeks'
    },
    {
      step: '06',
      title: 'Investment & Onboarding',
      description: 'Capital investment, equity transfer, and comprehensive partner onboarding program',
      duration: '1 week'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Partnership Process</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our streamlined process ensures thorough evaluation and smooth onboarding for qualified partners
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-emerald-200 hidden lg:block"></div>
          
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className={`flex flex-col lg:flex-row items-center ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                <div className="flex-1 lg:w-1/2">
                  <div className={`bg-white rounded-lg shadow-lg p-6 ${index % 2 === 0 ? 'lg:mr-8' : 'lg:ml-8'}`}>
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">
                        {step.step}
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900">{step.title}</h3>
                        <span className="text-sm text-emerald-600 font-medium">{step.duration}</span>
                      </div>
                    </div>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>
                
                <div className="hidden lg:block w-4 h-4 bg-emerald-600 rounded-full border-4 border-white shadow-lg z-10"></div>
                
                <div className="flex-1 lg:w-1/2"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Start?</h3>
            <p className="text-gray-600 mb-6">
              The entire partnership process typically takes 6-8 weeks from application to onboarding
            </p>
            <a
              href="#partnership-application"
              className="bg-emerald-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Begin Partnership Application
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
